import React from "react";
import { Star } from "lucide-react";

/**
 * Mirrors the testimonial card as it appears in the home page testimonials grid.
 */
const TestimonialPreview = ({ t = {} }) => {
  const rating = Math.max(1, Math.min(5, t.rating || 5));

  return (
    <div className="bg-slate-950 p-10 min-h-[400px]" data-testid="testimonial-preview">
      <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-6">
        Homepage · Testimonials section
      </div>
      <div className="max-w-md mx-auto">
        <div className="glass rounded-2xl p-7 relative overflow-hidden">
          <div className="absolute -top-6 -left-2 text-7xl font-display text-atc-green/10 select-none">"</div>

          <div className="flex items-center gap-1 mb-4 relative z-10">
            {Array.from({ length: rating }).map((_, i) => (
              <Star key={i} className="h-4 w-4 text-atc-green" style={{ fill: "#3FBF3F" }} />
            ))}
            {Array.from({ length: 5 - rating }).map((_, i) => (
              <Star key={`e${i}`} className="h-4 w-4 text-slate-700" />
            ))}
          </div>

          <p className="text-slate-200 text-base leading-relaxed relative z-10">
            "{t.quote || "Your quote will appear here."}"
          </p>

          <div className="mt-5 pt-5 border-t border-white/5 relative z-10">
            <div className="font-display font-bold text-white">{t.author || "Author name"}</div>
            {t.role && <div className="text-xs text-slate-400 mt-0.5">{t.role}</div>}
          </div>

          {!t.is_active && (
            <div className="mt-4 inline-block text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full bg-slate-700/30 text-slate-400 relative z-10">
              Hidden (won't appear on public site)
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TestimonialPreview;
